import { useState, useRef, useEffect } from "react";
import classes from "./ReportPage.module.css";
import autoTable from "jspdf-autotable";
import { dummyData } from "../utils/dummyData";
import { getActiveBranchIds1 } from "../util/multipleBranch/getActiveBranchId";
import { getTotalProgressPoints } from "../util/ReportGeneration/getTotalProgressPoints";
import {
  filterDataAtBranchLevel,
  filterSavedFeedbacksBranchWise,
} from "../util/filterSavedFeedbacks";
import { jsPDF } from "jspdf";
import exportAsImage from "../utils/exportAsImage";
import {
  tabulateStaffDataPDF,
  tabulateStaffRankingPDF,
} from "../util/ReportGeneration/tabulateStaffRakingPDF";
import { findNumberOfFeedbacks } from "../util/ReportGeneration/findNumberOfFeedback";
import { filterFeedbacksWithinDates } from "../util/FilterFeedbackWithinDates";
import NoDataComponent from "../components/NoDataComponent";
import PageContent from "../components/PageContent";
import DatePicker from "../components/ReportGen/DatePicker";
import FeedbackFilter from "../components/ReportGen/FeedbackFilter";
import BarChart from "../components/BarChart.js";
import RlineChartForBranches from "../components/ReportGen/RlineChartForBranches";
import PieChartCardReport from "../components/ReportGen/PieChartCardReport.js";
import { Pie } from "react-chartjs-2";
import { getBranchInfobyId } from "../util/multipleBranch/getActiveBranchId";
import StaffRanking from "../components/StaffRanking";
import ReportFeedback from "../components/ReportGen/ReportFeedback";
import { ratingBarGraph } from "../util/ratingBarGraph.js";
import { lineChartForBranches } from "../util/adminDashboard/lineChartForBranches.js";
import { genPieChartData1 } from "../util/genPieChartData1";
import { generateStaffData } from "../util/genStaffData";
import { reportLineChartGen } from "../util/ReportGeneration/linechartReporting.js";
import { ratingBarGraphReport } from "../util/ReportGeneration/ratingBarGraphReport.js";
import { getLastWeekDates } from "../util/ReportGeneration/getLastWeekMonthDates.js";
import {
  generateAttributionData,
  getAttribtionDataByBranchArray,
} from "../util/ReportGeneration/getAttributionData.js";
import { getNumOfDaysFromDates } from "../util/getLastNdays.js";
import { genStaffDataForReport } from "../util/ReportGeneration/staffDataGeneratorForReport.js";
/**
 * 
 in this we create a superData object wich stores all info of diff sections like(graph,staffInof,piecharts,feedbakc)
 ex formate of 
 
 superData =  [{title:"graph",isSelected:false,data:graphData}]

 now we just loop through this object to render our report preview.


 */

function calculateSectionData(data, dates = null) {
  const activeBranches = getActiveBranchIds1();
  // console.log(activeBranches);
  let numOfBranches = activeBranches.length;

  //STEP 1 calculating Graph data
  let graphData;

  if (numOfBranches == 1) {
    graphData = ratingBarGraphReport(data, dates);
    // console.log("graph data aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
    // console.log(ratingBarGraph(10, data));
    // console.log(ratingBarGraphReport(data, dates));
  } else {
    graphData = reportLineChartGen(data, dates);
  }
  //STEP 2 calculating Pie chart dtaa

  const newPieData = genPieChartData1(data);

  const actualPieData = readyPieData(newPieData);

  //STEP 3 calculating staff Data

  const staffData = genStaffDataForReport(data, dates);

  // console.log("uuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
  //console.log(staffData);

  // step 4 calculating filtering feedback data

  // step 5 we have to calculate attribution data as per the dates.
  let attributionData = generateAttributionData(data);
  //console.log(attributionData);
  //   const savedFeedbacks = filterSavedFeedbacksBranchWise(data, activeBranches);

  let obj = {
    graphData,
    newPieData: newPieData,
    staffData,
    attributionData,
  };

  return obj;
}

function readyPieData(data) {
  const readyPieData = data?.map((data) => {
    let objForEachQuestion = {
      qtitle: data.questionTitle,
      branchData: [],
    };
    let arrForOneBranch = data.dataForBranch.map((brData) => {
      let objForEachBranch = {
        branchName: brData.branchName,
        data: {},
      };

      let countData = [];
      brData.options.options.forEach((optionNcountObj) => {
        countData.push(optionNcountObj.count);
      });

      let data = {
        label: [],
        datasets: [
          {
            label: [], // this is left empty
            data: [...countData],
            backgroundColor: [
              "rgba(79, 60, 220, 1)",
              "rgba(71, 208, 119 )",
              "rgba(255, 206, 86 )",
              "rgba(255, 0, 55, 1)",

              "rgba(255, 159, 64 )",
              "rgba(75, 192, 192, 0.8)",
              "rgba(135, 29, 122, 1)",
            ],
            borderColor: [
              "rgba(79, 60, 220, 1)",
              "rgba(71, 208, 119 )",
              "rgba(255, 206, 86 )",
              "rgba(255, 0, 55, 1)",

              "rgba(255, 159, 64 )",
              "rgba(75, 192, 192, 0.8)",
              "rgba(135, 29, 122, 1)",
            ],
            borderWidth: 1,
          },
        ],
      };
      objForEachBranch.data = { ...data };

      return objForEachBranch;
    });
    objForEachQuestion.branchData = [...arrForOneBranch];

    return objForEachQuestion;
  });
  return readyPieData;
}

export default function ReportPage1() {
  //console.log("Rendering Report COmponent");
  const mainData1 = JSON.parse(sessionStorage.getItem("mainData"));
  console.log("main data in report page is ");
  console.log(mainData1);
  const mainData = mainData1;
  const [data, setData] = useState([]);

  //this will contiain all sections data. which will be looped to
  // show as report preview and generate report as well;
  const [superData, setSuperData] = useState([
    {
      title: "Attribution Data",
      data: null,
      isSelected: true,
      progressPoints: 2,
    },
    {
      title: "Graphs",
      data: null,
      isSelected: true,
      progressPoints: 8,
    },

    {
      title: "Pie Charts",
      data: null,
      isSelected: true,
      progressPoints: 40,
    },

    {
      title: "Staff Rankings",
      data: null,
      isSelected: true,
      progressPoints: 10,
    },

    {
      title: "Feedbacks",
      data: null,
      isSelected: false,
      progressPoints: 40,
    },
  ]);

  console.log(superData);
  const branches = JSON.parse(localStorage.getItem("branches"));
  const [branch, setBranch] = useState(branches);
  const activeBranches = getActiveBranchIds1();
  let numOfBranches = getActiveBranchIds1().length;

  const [reportDate, setReportDate] = useState([]);

  // this stores array of 2 dates submitted by user for prefereed data filteration component named DatePicker.

  // isDateChosen variable is used to decide whether datePicker
  // is shown or date String (fixed mode ) is shown.
  let isDateChosen = false;
  if (reportDate?.length == 2) {
    isDateChosen = true;
  }

  // the file name of the pdf file is date dependent hence will be sent by datePicker component.
  // hence we will send setFileName as prop inside datePicker
  const [fileName, setFileName] = useState("Report");
  //console.log("===========================================");
  //console.log(fileName);
  //Common Section

  // ref to store all the graphs canvase (graph n pie charts)
  const graphBlockRef = useRef([]);

  const [pdfProgress, setPdfProgress] = useState(0);

  //calculating data

  //calculateSectionData function accepts data and calculates
  // data for all 4 section and returns an object. except for feedbacks
  //console.log(typeof reportDate);
  //console.log("dd");
  //console.log(reportDate[0]);
  let obj = calculateSectionData(data, reportDate);

  let graphData = obj.graphData;
  let newPieData = obj.newPieData;
  let staffData = obj.staffData;
  const actualPieData = readyPieData(newPieData);
  let attributionData = obj.attributionData;

  //Feedback section calculation
  //feedFilter is BOOLENA to decide, if feedback checkbox clicked\
  // only then feedback filter dispay/box is shown else hidden.
  const [isFeedbackFilter, setIsFeedbackFilter] = useState(false);
  //console.log(isFeedbackFilter);
  const [filteredFeedbackData, setFilteredFeedbackData] = useState([]);

  // this ref array would store feedback screenshot(canvas images)
  const feedbackBlockRef = useRef([]);

  let f = 0; // to tack num of feedback n store as array in above ref

  let ij = 0; // to keep track of piechart while storing in ref variable. for DOM binding for conversion to imag.

  let progressPercentage =
    (pdfProgress * 100) / getTotalProgressPoints(superData);

  function setSuperDataHandler(obj) {
    //console.log("setting super data");
    let graphData = obj.graphData;
    let newPieData = obj.newPieData;
    let staffData = obj.staffData;
    let savedFeedbacks = filteredFeedbackData;

    setSuperData((prev) => {
      const output = prev.map((item, index) => {
        let tempItem;
        if (item.title == "Attribution Data") {
          tempItem = { ...item, data: attributionData };
        }
        if (item.title == "Graphs") {
          tempItem = { ...item, data: graphData };
        }
        if (item.title == "Pie Charts") {
          //console.log(newPieData);
          tempItem = { ...item, data: newPieData };
        }
        if (item.title == "Staff Rankings") {
          tempItem = { ...item, data: staffData };
        }
        if (item.title == "Feedbacks") {
          tempItem = { ...item, data: savedFeedbacks };
        }

        return tempItem;
      });
      return output;
    });
  }

  function branchSelector(e) {
    setPdfProgress(0);
    let index = e.target.id;
    // we have to re calculating all data values such as newPieData
    //

    //UPDATING Branches status which is selected whis is not.
    let newBranchStatus = branches.map((prev, smallIndex) => {
      if (index == smallIndex) {
        let obj = { ...prev, isActive: !prev.isActive };
        return obj;
      }
      return prev;
    });

    localStorage.setItem("branches", JSON.stringify(newBranchStatus));
    setBranch(newBranchStatus);

    // step 1 filtering the feedback data branchwise.
    let d4 = filterFeedbacksWithinDates(mainData, reportDate[0], reportDate[1]);
    const data1 = filterDataAtBranchLevel(d4, getActiveBranchIds1());
    // console.log(getActiveBranchIds1());
    // console.log(d4);

    // console.log(data1);
    setData(data1);

    const savedFeedbacks = filterSavedFeedbacksBranchWise(
      data1,
      getActiveBranchIds1()
    );

    setFilteredFeedbackData(savedFeedbacks);

    // recalculating  all sections data

    let obj = calculateSectionData(data1);
    //console.log(obj);
    let graphData = obj.graphData;
    let newPieData = obj.newPieData;
    let staffData = obj.staffData;
    //console.log(newPieData);

    //Recalculating feedbacks

    obj.savedFeedbacks = savedFeedbacks;

    setSuperDataHandler(obj);
  }

  // sets state variable =boolen = whether to show feedback filter window
  function feedbackFilterHandler() {
    //console.log("feedback checkobox select");
    //console.log(isFeedbackFilter);
    // this state varible decides whether to show feedback filter component or not.
    setIsFeedbackFilter((prev) => {
      //console.log(prev);
      return !prev;
    });
  }

  function sectionSelector(e) {
    setPdfProgress(0);
    let indexNumClicked = e.target.name;
    if (indexNumClicked == 4) {
      feedbackFilterHandler();
    }

    setSuperData((prev) => {
      const output = prev.map((item, index) => {
        let tempItem;
        if (index == indexNumClicked) {
          let ans = item.isSelected;
          tempItem = { ...item, isSelected: !ans };
        } else {
          tempItem = { ...item };
        }

        return tempItem;
      });
      return output;
    });
  }

  function printingPageNumber(doc, height, fSize) {
    let alreadyFontNumber = doc.getFontSize;

    doc.setFontSize(fSize);

    const pageCount = doc.internal.getNumberOfPages();
    doc.text(`P ${pageCount}`, 105, height, "center");

    doc.setFontSize(alreadyFontNumber);
  }

  async function createPDF(data, superData1, setPdfProgess, fName) {
    // data is raw feedback data only use to see if its null return null.

    //console.log(graphBlockRef.current);
    let progress = 0;
    setPdfProgess(0);

    //console.log(data);
    //console.log(superData1);
    if (data == null) return;

    let doc = new jsPDF("p", "mm", "a4", true);
    // total num of pages

    // add true as last argument to above statement to compress pDf
    let topMargin = 20;
    let leftMargin = 15;
    let vertical = topMargin;
    let horizontal = leftMargin;
    let fontSize1 = 20;
    let fontSize2 = 15; // this is in pixels
    let fontSize3 = 10;
    let heightOfHeading = fontSize1 / 2.8;
    let heightOfText = fontSize2 / 2.8;
    let pageNumberHeight = 290;
    doc.setFontSize(fontSize1);

    let i = 0; // this i track all image of graphs n charts stored as array in ref variable.
    let m5 = 5; // margin gap
    let m2 = 2.5;

    doc.text("REPORT", 105, vertical, "center");

    printingPageNumber(doc, pageNumberHeight, fontSize3);

    // to center a text give "center" argument and x is center of page.

    vertical += heightOfHeading + m5;

    doc.setFontSize(fontSize1);
    //console.log(reportDate[0].toLocaleDateString("en-IN"));
    doc.text(
      `${reportDate[0].toLocaleDateString(
        "en-IN"
      )} - ${reportDate[1].toLocaleDateString("en-IN")}`,
      105,
      vertical,
      "center"
    );
    vertical += m5 * 3;

    //console.log(graphBlockRef.current);

    /** we will loop through superData1 which is passed in this function and is
     * a state variable storing all the different data required to display and print a pdf
     */
    // we use forloop to loop and not forEach because await functions dont work in forEach.- its synchronouse.
    for (let j = 0; j < superData1.length; j++) {
      const data = superData1[j];
// SECTION >>>>>>>>>>>>>>>>>>>>>>>>>>>>
      if (
        data.title == "Attribution Data" &&
        data.isSelected == true &&
        data.data != null
      ) {
        doc.text("Attribution Data", 105, vertical, "center");
        vertical += heightOfHeading;
        console.log(vertical, horizontal);
        let box1W = 60;
        let boxL = 50;
        let box2W = 95;

        let branchContainerW = 170;
        let branchContainerL = 70;
        let boxGap = 5;
        let branchContainerStartVertical = 60;
        let boxesStartVertical = 0;
        // use m2 and m5 as margin gaps
        console.log(horizontal, vertical);

        // printing branch contianer
        // doc.react(x,y,widht,height)
        console.log(vertical);
        let attributionData = data.data;
        console.log(attributionData);
        for (let i = 0; i < attributionData.length; i++) {
          vertical = branchContainerStartVertical;
 
          if (vertical > 220) {
            console.log("adding new page");
            doc.addPage();
            // printingPageNumber(doc, pageNumberHeight, fontSize3);
            vertical = topMargin;
            branchContainerStartVertical = vertical;
            // printingPageNumber(doc, pageNumberHeight, fontSize2);
          }
          boxesStartVertical =
            branchContainerStartVertical + heightOfHeading * 2 + m5 * 3;

          // printing branch BOX
          doc.rect(horizontal, vertical, branchContainerW, branchContainerL);
          horizontal += m5;
          vertical += m2;
          // printing branch name

          let bName = getBranchInfobyId(attributionData[i].branchId).name;
          doc.text(`${bName}`, 105, vertical + heightOfHeading, "center");
          vertical += heightOfHeading + m5;
          console.log(vertical);
          // printing small box for repeat cusotmer
          doc.rect(horizontal, vertical, box1W, boxL);

          // printing bigger box of for attribution data.
          doc.rect(horizontal + box1W + boxGap, vertical, box2W, boxL);

          doc.text(
            "Repeat Customer",
            horizontal + m2,
            vertical + heightOfHeading
          );
          console.log("flag2");
          doc.text(
            "Attribution Analysis",
            horizontal + box1W + boxGap + 15,
            vertical + heightOfHeading
          );

          // first we print inside attribution analysis box

          horizontal = horizontal + box1W + boxGap + m2;
          vertical = vertical + heightOfHeading + m5 + m5;

          doc.setFontSize(fontSize2);
          let optionsArr = attributionData[i].attributionData.options;
          let attributionValues =
            attributionData[i].attributionData.attribution;
          let loopVertical = vertical;
          for (let i = 0; i < optionsArr.length; i++) {
            let str = `> ${optionsArr[i]} - ${attributionValues[i]}%`;
            let newStr = doc.splitTextToSize(str, box2W - m2);
            let textHeight = doc.getTextDimensions(newStr).h;

            doc.text(newStr, horizontal, loopVertical);
            loopVertical += textHeight + m2;
          }

          // now print inside repeat cusotmer
          horizontal = leftMargin + m5 + m2;

          doc.setFontSize(fontSize1 + fontSize2);
          let repeatPercentage =
            attributionData[i].repeatCustomerData.repeatPercent;
          console.log(attributionData[i]);
          doc.text(
            `${repeatPercentage}%`,
            50,
            boxesStartVertical + 15,
            "center"
          );
          doc.setFontSize(fontSize1);
          // doc.text("dd", horizontal, boxesStartVertical);

          branchContainerStartVertical += branchContainerL;
          horizontal = leftMargin;
          // end of loop
        }

        setPdfProgess((progress += 2));
        printingPageNumber(doc, pageNumberHeight, fontSize3);

        // add new Page.
         doc.addPage();
          vertical = topMargin;
          horizontal = leftMargin;
            printingPageNumber(doc, pageNumberHeight, fontSize3);
      }

      //11111111111111111 BEGINS INTRO N BAR?LINE CHARRTS PAGE!
// SECTION >>>>>>>>>>>>>>>>>>>>>>>>>>>>
      if (
        data.title == "Graphs" &&
        data.isSelected == true &&
        data.data != null
      ) {
        //PRINTING GRAPHS
        // if (superData1[j - 1].isSelected == true) {
        //   // ie attribution data was printed then start on fresh page
        //   doc.addPage();
        //   vertical = topMargin;
        //   horizontal = leftMargin;
        //   printingPageNumber(doc, pageNumberHeight, fontSize3);
        // } else {
        //   vertical = 40;
        // }

        let widthOfGraph = 175;
        let heightOfGraph = 120;

        for (let a = 0; a < numOfBranches; a++) {
          horizontal = 105 - widthOfGraph / 2;
          let pieImage = await exportAsImage(
            graphBlockRef.current[i++].firstChild
          );
          doc.addImage(
            pieImage,
            "png",
            horizontal,
            vertical,
            widthOfGraph,
            heightOfGraph
          );

          vertical += heightOfGraph + m5;
          //console.log(vertical);
        }

     

        //111111111111111111 ENDS INTRO N BAR?LINE CHARRTS PAGE!
        setPdfProgess((progress += 8)); // 10

        // adding new page
          doc.addPage();
          vertical = topMargin;
          horizontal = leftMargin;
            printingPageNumber(doc, pageNumberHeight, fontSize3);
      }
     

      if (
        data.title == "Pie Charts" &&
        data.isSelected == true &&
        data.data != null
      ) {
  //2222222222222222222222BEGINS++++++ PRINTING PIE CHARTS IN PDF
   
        // formating data for PIE CHART
        const pieData = readyPieData(data.data);
        // console.log(pieData);

        //Creating variable for storing VERTICAL level for pdf
        let levelHeading = topMargin;
        let heightOfPieChartCard = 270 / 2.8;

        // let levelBranch = levelHeading + heightOfHeading;
        let levelPieChartCard = levelHeading + fontSize1 / 2.8;

        let heightOfPieSection = heightOfHeading + heightOfPieChartCard;

        //Creating Variable for Column/ horzontal gaps. 3 columns.
        let widthOfPieSection = 165 / 2.8;
        let col1 = topMargin;
        let col2 = col1 + widthOfPieSection;
        let col3 = col2 + widthOfPieSection;

        //LOOP STARTS sssssssssssssssssssssssssss
        //LEVEL 1 of LOOPING

        let progressPerPie = 40 / (pieData.length * numOfBranches);

        // 40 progress points for pie charts
        for (let a = 0; a < pieData.length; a++) {
          let pdata = pieData[a];
          let superIndex = a;

          if (vertical > 280 - heightOfPieSection) {
            doc.addPage();
            printingPageNumber(doc, pageNumberHeight, fontSize3);
            levelHeading = topMargin;
            horizontal = topMargin;
            vertical = leftMargin;
          }
          horizontal = col1;

          doc.setFontSize(fontSize1);

          doc.text(pdata.qtitle, horizontal, vertical);

          // level 2 - branch level
          vertical += m5;
          for (let b = 0; b < pdata.branchData.length; b++) {
            let branch = pdata.branchData[b];
            let bIndex = b;

            // checking if space available for one more pie chart
            // basically these ifs will bever be true for first pie chart.
            if (horizontal > 200 - widthOfPieSection) {
              horizontal = topMargin;
              vertical += heightOfPieChartCard + m5;
              levelPieChartCard = vertical;
            }
            if (vertical > 280 - heightOfPieSection) {
              doc.addPage();
              printingPageNumber(doc, pageNumberHeight, fontSize3);
              levelHeading = topMargin;
              horizontal = topMargin;
              vertical = leftMargin;
            }
            // goin in level 3 options.options for actual pie data
            let pieImage = await exportAsImage(
              graphBlockRef.current[i++].firstChild
            );
            doc.addImage(
              pieImage,
              "png",
              horizontal,
              vertical,
              widthOfPieSection,
              heightOfPieChartCard
            );

            horizontal += widthOfPieSection + m5;
            setPdfProgess((progress += progressPerPie)); // shud be 50
          }
          vertical += heightOfPieSection + m5;
        }

        horizontal = leftMargin;
        vertical = topMargin;

        //22222222222222222 ENDS ++++++++++++++++ PRINTING OF PIECHARTS
        // Adding new Page for next section.
          doc.addPage();
          vertical = topMargin;
          horizontal = leftMargin;
            printingPageNumber(doc, pageNumberHeight, fontSize3);
      }

      if (
        data.title == "Staff Rankings" &&
        data.isSelected == true &&
        data.data != null
      ) {
        // if (
        //   superData1[0].isSelected == true ||
        //   superData1[1].isSelected == true ||
        //   superData[2].isSelected == true
        // ) {
        //   //console.log("it not new page");
        //   // means checking if feedback section is first one to be printed then no need to addNew Page.
        //   doc.addPage();
        //   vertical = topMargin;
        //   horizontal = leftMargin;
        //   printingPageNumber(doc, pageNumberHeight, fontSize3);
        // }

        // 33333333333333333 STARTS STAFF SECTION`
        //console.log(data.data);
        const staffTabularData = tabulateStaffDataPDF(data.data);

        doc.setFontSize(fontSize1);

        doc.text("Staff Performance", 105, vertical, "center");
        vertical += heightOfHeading + m2;
        doc.setFontSize(fontSize1);

        for (let a = 0; a < staffTabularData.length; a++) {
          //console.log(staffTabularData[a].data);
          if (vertical > 220) {
            doc.addPage();
            printingPageNumber(doc, pageNumberHeight, fontSize3);
            vertical = topMargin;
          }
          //console.log(branches.length);
          if (branches.length > 1) {
            //console.log(branches);
            doc.text(
              `${staffTabularData[a].branchName}`,
              105,
              vertical,
              "center"
            );
            vertical += heightOfText;
          }

          doc.autoTable({
            theme: "striped",
            startY: vertical,
            styles: { fillColor: [182, 207, 250] },
            headStyles: { fontSize: 10 },
            bodyStyles: { fontSize: 8, fontStyle: "italic" },

            head: [["Name", "Score", "Average Score"]],
            body: staffTabularData[a].data,
          });

          let heightOfTable = 10 + staffTabularData[a].data.length * 8 + m5;
          vertical += heightOfTable;
        }

        // 333333333333333333 ENDS STAFF SECTION
        setPdfProgess((progress += 10)); //shud be 60
        // if (superData[3].isSelected == true) {
        //   doc.addPage();
        //   printingPageNumber(doc, pageNumberHeight, fontSize3);
        // }

        // Adding New Page for next section
        if(superData1[j+1].isSelected == true){
            doc.addPage();
          vertical = topMargin;
          horizontal = leftMargin;
            printingPageNumber(doc, pageNumberHeight, fontSize3);
        }
      }

      // 40 progress point for all feedbacks

      if (
        data.title == "Feedbacks" &&
        data.isSelected == true &&
        data.data != null
      ) {
        let progressPointPerFeedback = 40 / findNumberOfFeedbacks(data.data);
        // console.log("ffffffffffffffffffffffffffff");
        // console.log(findNumberOfFeedbacks(data.data));
        // console.log(progressPointPerFeedback);
        let feedbackTopMargin = 5;
        let feedbackLeftMargin = 5;
        if (
          superData1[0].isSelected == true ||
          superData1[1].isSelected == true ||
          superData1[2].isSelected == true
        ) {
          //console.log("it not new page");
          // means checking if feedback section is first one to be printed then no need to addNew Page.
          doc.addPage();
          printingPageNumber(doc, pageNumberHeight, fontSize3);
          vertical = feedbackTopMargin;
        } else {
          //console.log(superData1[j - 1].isSelected);
          //console.log("feedback is first section");
        }
        // 44444444444444444444 STARTS FEEDBACK SECTION

        horizontal = feedbackLeftMargin;
        let widthOfFeedback = 100;
        let heightOfFeedback = 140;
        let fs = 0;

        for (let a = 0; a < feedbackBlockRef.current.length; a++) {
          let source = feedbackBlockRef.current[a];
          if (source == null) break;
          let feedbackImage = await exportAsImage(source);
          doc.addImage(
            feedbackImage,
            "png",
            horizontal,
            vertical,
            widthOfFeedback,
            heightOfFeedback
          );

          horizontal += widthOfFeedback;
          if (horizontal > 160) {
            horizontal = feedbackLeftMargin;
            vertical += heightOfFeedback;
          }
          if (vertical > 160) {
            doc.addPage();
            printingPageNumber(doc, pageNumberHeight, fontSize3);

            horizontal = feedbackLeftMargin;
            vertical = feedbackTopMargin;
          }
          setPdfProgess((progress += progressPointPerFeedback));
        }

        // ENDS FEEDBACK SEXtion
      }
    }

    // adding end of report line
    doc.setFontSize(fontSize3);
    doc.text("End Of Report --          --  End Of Report", 105, 290, "center");

    // for testing use doc.output to prevenet unnecessary download
    // doc.output("dataurlnewwindow");
    doc.save(`${fName}.pdf`);
  }

  //use effects

  // using useEffect to update data state whenever we get report date array
  useEffect(() => {
    // console.log("dates hit");
    let activeBranches = getActiveBranchIds1();
    //console.log(activeBranches);
    if (reportDate.length == 2) {
      //console.log("setting the data");

      let d5 = filterFeedbacksWithinDates(
        mainData,
        reportDate[0],
        reportDate[1]
      );
      const d4 = filterDataAtBranchLevel(d5, activeBranches);
      //   console.log(d4);

      setData(d4);
      // setting feedback data after segregating branchwise.

      setFilteredFeedbackData(
        filterSavedFeedbacksBranchWise(d4, activeBranches)
      );

      // calculating fresh graph data and piedata adn everydata.

      let obj = calculateSectionData(d4);

      let graphData = obj.graphData;
      let newPieData = obj.newPieData;
      let staffData = obj.staffData;
      let attributionData = obj.attributionData;
      let feedbackData = filteredFeedbackData;

      //   setSuperDataHandler(obj);

      setSuperData((prev) => {
        const output = prev.map((item, index) => {
          let tempItem;
          if (item.title == "Attribution Data") {
            tempItem = { ...item, data: attributionData };
          }
          if (item.title == "Graphs") {
            //console.log(graphData);
            tempItem = { ...item, data: graphData };
          }
          if (item.title == "Pie Charts") {
            //console.log(newPieData);
            tempItem = { ...item, data: newPieData };
          }
          if (item.title == "Staff Rankings") {
            tempItem = { ...item, data: staffData };
          }
          if (item.title == "Feedbacks") {
            tempItem = { ...item, data: feedbackData };
          }

          return tempItem;
        });
        return output;
      });
      //console.log("fl2");
    }
  }, [reportDate?.length, reportDate[0], reportDate[1]]);

  useEffect(() => {
    //console.log("DETECTED CHANGE IS FEEDBACK DATA");
    //console.log(filteredFeedbackData);
    let feedbackSelected = true;

    setSuperData((prev) => {
      const output = prev.map((item, index) => {
        let tempItem;
        if (item.title == "Attribution Data") {
          tempItem = { ...item, data: attributionData };
        }
        if (item.title == "Graphs") {
          tempItem = { ...item, data: graphData };
        }
        if (item.title == "Pie Charts") {
          //console.log(newPieData);
          tempItem = { ...item, data: newPieData };
        }
        if (item.title == "Staff Rankings") {
          tempItem = { ...item, data: staffData };
        }
        if (item.title == "Feedbacks") {
          tempItem = {
            ...item,
            data: filteredFeedbackData,
          };
        }

        return tempItem;
      });
      return output;
    });
  }, [filteredFeedbackData]);

  if (data == null) return <NoDataComponent />;

  //console.log("super data is ");
  //console.log(superData);

  //END OF COMPONENT CODE

  //JSX BEGINS
  return (
    // =========================================================
    // ==========================================================
    // pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppp
    // ================================================================
    // ============================================================
    // pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppp
    // ================================================================
    <>
      <PageContent>
        <p>Report Builder</p>

        <div className={classes.DateComponentContainer}>
          <DatePicker setReportDate={setReportDate} setFileName={setFileName} />
        </div>
        {isDateChosen ? (
          <>
            {branches.length > 1 && (
              <div className={classes.branchContainer}>
                <p>Branches</p>
                {branch.map((b, index) => {
                  return (
                    <div key={`feed${index}`}>
                      <input
                        type="checkbox"
                        id={`${index}`}
                        name={`${b.shortName}`}
                        value={`${b.shortName}`}
                        onChange={(e) => {
                          branchSelector(e);
                        }}
                        checked={branch[`${index}`].isActive}
                      ></input>
                      <label
                        htmlFor={`${b.shortName}`}
                      >{`${b.shortName}`}</label>
                    </div>
                  );
                })}
              </div>
            )}
            <div className={classes.sectionController}>
              {superData.map((dataObj, index) => {
                return (
                  <div
                    className={classes.sectionControllerInput}
                    key={`m${index}ppp`}
                  >
                    <input
                      type="checkbox"
                      name={`${index}`}
                      checked={dataObj.isSelected}
                      onChange={(e) => {
                        sectionSelector(e);
                      }}
                    />
                    <label>{`${dataObj.title}`}</label>
                  </div>
                );
              })}
            </div>
            {isFeedbackFilter && (
              <>
                <FeedbackFilter
                  data={data}
                  setFilteredFeedbackData={setFilteredFeedbackData}
                />
              </>
            )}
            <div className={classes.progressBarContainer}>
              <div className={classes.progressBarOuter}>
                <div
                  className={classes.progressBarFiller}
                  style={{
                    width: `${progressPercentage}%`,
                  }}
                ></div>
              </div>
            </div>
            <button
              onClick={() => {
                // console.log(graphBlockRef.current[1].firstChild);
                createPDF(data, superData, setPdfProgress, fileName);
              }}
            >
              Generate Report
            </button>{" "}
          </>
        ) : (
          <div key={`okoko`}> </div>
        )}
        <div className={classes.reportContainer} id="reportPreview">
          <h2>Report</h2>
          {reportDate.length == 2 && (
            <p>{`${reportDate[0].toLocaleDateString(
              "en-in"
            )} - ${reportDate[1].toLocaleDateString("en-in")}`}</p>
          )}

          {superData.map((data, index) => {
            {
              if (
                data.title == "Attribution Data" &&
                data.isSelected == true &&
                data.data != null
              ) {
                //console.log(data.data);
                return (
                  <div key={`atttr ${index}`}>
                    <h4>Attribution Analysis</h4>
                    <div>
                      {data.data.map((item, index) => {
                        return (
                          <div
                            key={`tttt${index}`}
                            className={classes.attributionBox}
                          >
                            <p>{getBranchInfobyId(item.branchId).name}</p>

                            <p>
                              Repeat Customer -{" "}
                              {item.repeatCustomerData.repeatPercent}%
                            </p>

                            <h4>Attribution Information</h4>

                            {item.attributionData.options.map((e, index) => {
                              return (
                                <div
                                  className={classes.attributionInfoContainer}
                                  key={`aaa${index}`}
                                >
                                  <p>
                                    {e} -{" "}
                                    {item.attributionData.attribution[index]}%
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              }

              if (
                data.title == "Graphs" &&
                data.isSelected == true &&
                data.data != null
              ) {
                return (
                  <div
                    className={`${classes.graphContainer} graph`}
                    key={`${index}tt`}
                  >
                    {numOfBranches == 1 && (
                      <div
                        className={classes.barChartContainer}
                        ref={(ref) => (graphBlockRef.current[`${ij++}`] = ref)}
                      >
                        <BarChart data={data.data} />
                      </div>
                    )}

                    {numOfBranches > 1 && (
                      <>
                        {" "}
                        <div
                          className={`${classes.graphContainer} graph`}
                          ref={(ref) =>
                            (graphBlockRef.current[`${ij++}`] = ref)
                          }
                        >
                          <div>
                            <h3>1 Star Ratings</h3>
                            <RlineChartForBranches data={data.data[0]} />
                          </div>
                        </div>
                        <div
                          className={`${classes.graphContainer} graph`}
                          ref={(ref) =>
                            (graphBlockRef.current[`${ij++}`] = ref)
                          }
                        >
                          <div>
                            <h3>5 Star Ratings</h3>
                            <RlineChartForBranches data={data.data[1]} />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                );
              }

              if (
                data.title == "Pie Charts" &&
                data.isSelected == true &&
                data.data != null
              ) {
                return (
                  <div className={`${classes.pieContainer} pieChart`}>
                    {
                      <div className={classes.pieChartContainer}>
                        {data.data.map((pdata, superIndex) => {
                          return (
                            <div
                              key={`${superIndex}fdeeg`}
                              className={classes.pieQuestionContainer}
                            >
                              <h3>{pdata.questionTitle}</h3>
                              <div className={classes.pieContainer}>
                                {pdata.dataForBranch.map(
                                  (branchData, bIndex) => {
                                    return (
                                      <div
                                        key={`${bIndex}qwqwq`}
                                        className={`pieChartBlock`}
                                        ref={(ref) =>
                                          (graphBlockRef.current[`${ij++}`] =
                                            ref)
                                        }
                                      >
                                        <PieChartCardReport
                                          bName={branchData.branchName}
                                          data={
                                            data.data[superIndex].dataForBranch[
                                              bIndex
                                            ].options
                                          }
                                          pData={
                                            actualPieData[superIndex]
                                              .branchData[bIndex].data
                                          }
                                        >
                                          <Pie
                                            data={
                                              actualPieData[superIndex]
                                                .branchData[bIndex].data
                                            }
                                            options={{
                                              animation: {
                                                duration: 0,
                                              },
                                            }}
                                          />
                                        </PieChartCardReport>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    }
                  </div>
                );
              }

              if (
                data.title == "Staff Rankings" &&
                data.isSelected == true &&
                data.data != undefined
              ) {
                return (
                  <div className={classes.staffContainer}>
                    <h2>Staff Rankings</h2>
                    {data.data?.map((d, index) => {
                      return (
                        <div
                          key={`${index}${d.bId}gl4l`}
                          className={classes.branchStaffContainer}
                        >
                          {branches.length > 1 && (
                            <h4>{getBranchInfobyId(d.bId).name}</h4>
                          )}
                          <StaffRanking data={d.tableData} />
                        </div>
                      );
                    })}
                  </div>
                );
              }
              if (data.title == "Feedbacks" && data.isSelected == true) {
                return (
                  <div className={classes.feedbackSectionContainer}>
                    <h2>Feedbacks</h2>
                    {data.data.map((branchData, index) => {
                      return (
                        <div
                          className={classes.branchSection}
                          key={`${index}q992z`}
                        >
                          {branches.length > 1 && (
                            <h4>{getBranchInfobyId(branchData.bId).name}</h4>
                          )}
                          <div className={classes.branchLevelFeedbackContainer}>
                            {branchData.data.map((d3, index) => {
                              return (
                                <div
                                  key={`${index}qqa22z`}
                                  className={classes.reportFeedback}
                                  ref={(ref) =>
                                    (feedbackBlockRef.current[`${f++}`] = ref)
                                  }
                                >
                                  <ReportFeedback data={d3} />{" "}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }
            }
          })}
        </div>
      </PageContent>
    </>
  );
}
